import classnames from 'classnames';
import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase * 2,
    flexWrap: 'wrap',
  },
  iconContainer: {
    backgroundColor: theme.colors.blueMuted,
    color: theme.colors.blueAccessible,

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    borderRadius: theme.iconSize.huge / 2,

    width: theme.iconSize.huge,
    height: theme.iconSize.huge,
  },
  title: {
    ...theme.fonts.h5,
  },
  text: {
    ...theme.fonts.body,
    color: theme.colors.inkSecondary,
  },
  icon: {
    fontSize: theme.iconSize.large,
    fontWeight: 400,
  },
}));

interface Props {
  icon: string;
  title: string;
  text?: string;
  children?: React.ReactNode;
}

export const CreditsInfosBlock = ({ children, icon, title, text }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.container}>
      <div className={classes.iconContainer}>
        <i className={classnames(classes.icon, icon)} />
      </div>
      <h5 className={classes.title}>{title.toUpperCase()}</h5>
      <p className={classes.text}>
        {text}
        {children}
      </p>
    </div>
  );
};
